import { Tooltip, Typography } from 'antd';
import React, { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import FarmbotGridIcon from 'components/icons/FarmbotGridIcon';
import { SEARCH_PARAMS } from 'constants/search-params';

import './styles.less';

const { Paragraph } = Typography;

interface BackOfficeDeviceMapDeviceMarkerProps {
  lat: number;
  lng: number;
  deviceId: number;
  name: string;
  serialNumber: string;
  enterpriseName: string;
  ownerName: string;
}

function BackOfficeDeviceMapDeviceMarker({
  lat,
  lng,
  deviceId,
  name,
  serialNumber,
  enterpriseName,
  ownerName
}: BackOfficeDeviceMapDeviceMarkerProps): JSX.Element {
  const [, setSearchParams] = useSearchParams();

  const handleClick = useCallback(() => {
    setSearchParams((prev) => {
      const newSearchParams = new URLSearchParams(prev);
      newSearchParams.set(SEARCH_PARAMS.BACK_OFFICE.SELECTED_DEVICE, String(deviceId));
      return newSearchParams;
    });
  }, [deviceId, setSearchParams]);

  return (
    <div className="BackOfficeDeviceMapDeviceMarker" onClick={handleClick}>
      <div className="BackOfficeDeviceMapDeviceMarker-inner">
        <div className="BackOfficeDeviceMapDeviceMarker-pin" />
        <Tooltip
          title={
            <Typography className="BackOfficeDeviceMapDeviceMarker-tooltip">
              <Paragraph copyable>{lat.toFixed(5)}, {lng.toFixed(5)}</Paragraph>
              <Paragraph strong>{name}</Paragraph>
              <Paragraph copyable className="serial-number">{serialNumber}</Paragraph>
              <Paragraph>{enterpriseName}</Paragraph>
              <Paragraph>{ownerName}</Paragraph>
            </Typography>
          }
        >
          <div className="BackOfficeDeviceMapDeviceMarkerButton">
            <FarmbotGridIcon />
          </div>
        </Tooltip>
      </div>
    </div>
  );
}

export default BackOfficeDeviceMapDeviceMarker;
